import React, { useEffect, useState } from "react";
import {
  CategoryIcon,
  Content1Icon,
  Content2Icon,
  Content3Icon,
  FacebookIcon,
  LinkedinIcon,
  LocationIcon,
  PhoneIcon,
  TwitterIcon,
  WhatsappIcon,
} from "../icons";
import { motion } from "framer-motion";
import { Menu, Transition } from "@headlessui/react";
import { toast } from "react-toastify";
import CookieConsent from "../components/cookie-consent";
import {
  extractFirstImageSrc,
  formatDateTimeWithDay,
  navigationsFooter,
} from "../utils/common";
import Footer from "../layout/footer";
import { isEmpty } from "lodash";
import Header from "../layout/header";
import {
  FacebookShareButton,
  FacebookShareCount,
  HatenaShareCount,
  LineShareButton,
  LinkedinShareButton,
  OKShareCount,
  PinterestShareCount,
  RedditShareCount,
  TumblrShareCount,
  TwitterShareButton,
  VKShareCount,
} from "react-share";

const motors = [
  {
    image: "/assets/images/motor-1.png",
    label: "InfinX “X09”",
    description: "Energie : Électrique",
  },
  {
    image: "/assets/images/motor-2.png",
    label: "TVS HLX 150",
    description: "Energie : Essence",
  },
  {
    image: "/assets/images/motor-3.png",
    label: "Apsonic X1. AP50",
    description: "Energie : Essence",
  },
  {
    image: "/assets/images/motor-4.png",
    label: "Taxi jaune RY 150ZK",
    description: "Energie : Essence",
  },
  {
    image: "/assets/images/motor-1.png",
    label: "Suziki Alto",
    description: "Energie : Essence",
  },
];

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const slideUp = {
  hidden: { opacity: 0, y: 50 },
  visible: { opacity: 1, y: 0 },
};

const slideLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0 },
};

const slideRight = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0 },
};

export default function HomePage() {
  const [loading, setIsLoading] = React.useState<boolean>(false);

  const buttonRef = React.useRef<any>(null);
  const [data, setData] = useState<
    {
      id: number;
      code: string;
      title: string;
      content: string;
      date: string;
    }[]
  >([]);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    message: "",
  });

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    const data = new FormData();
    data.append("Nom", formData.fullName);
    data.append("Email", formData.email);
    data.append("Message", formData.message);

    const body = {
      Nom: formData.fullName,
      Email: formData.email,
      Message: formData.message,
    };

    const Sheet_Url =
      "https://sheet.best/api/sheets/c62d1ef6-c885-405d-952b-72e017181245";
    try {
      await fetch(Sheet_Url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      toast.success("Vos informations ont été enregistrer");

      setFormData({
        fullName: "",
        email: "",
        message: "",
      });
    } catch (error) {
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenMenu = () => {
    if (buttonRef.current) {
      buttonRef.current.click(); // Simule un clic sur le bouton pour ouvrir le menu
    }
  };

  const fetchBlog = async () => {
    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error("Failed to add row");
        }
        const result = await response.json();
        setData(result);
        break;
      } catch (error: any) {
        if (attempt === 3) {
          throw new Error(
            `Failed to fetch data after ${3} attempts: ${error.message}`
          );
        }
      }
    }
  };

  useEffect(() => {
    fetchBlog();
  }, []);

  return (
    <main className="px-4 md:px-6 lg:px-8 xl:px-16 h-full w-full md:max-w-[100rem] 2xl:max-w-[2560px] md:mx-auto gap-6 font-dmsans  py-4 md:py-6">
      <Header />
      <section className="w-full h-[700px] md:h-[1000px] bg-sm-banner md:bg-banner bg-cover bg-center bg-no-repeat rounded-2xl pt-16 lg:pt-32 ">
        <div className="flex flex-col max-w-sm md:max-w-4xl mx-auto gap-6">
          <motion.h1
            className="font-medium text-3xl md:text-7xl text-white text-center"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1 }}
          >
            Préservez votre Trésorerie en roulant InfinX
          </motion.h1>
          <div className="flex flex-col max-w-xl mx-auto gap-6">
            <motion.p
              className="font-medium text-base lg:text-xl text-white/75 text-center px-2 md:px-0"
              initial="hidden"
              whileInView="visible"
              variants={fadeIn}
              transition={{ duration: 1, delay: 0.2 }}
            >
              Vous êtes indépendant de la livraison ou des transports ? Payez
              votre véhicule comme si c'était une location
            </motion.p>
            <div className="grid grid-cols-2 gap-4 px-2 md:px-0">
              <motion.button
                className="bg-white hover:bg-white/80 font-semibold text-[11px] md:text-lg text-primary-30 h-12 lg:px-10 w-full  rounded-full"
                initial="hidden"
                whileInView="visible"
                variants={slideUp}
                transition={{ duration: 1, delay: 0.4 }}
              >
                <a href="#our-models">Par ici le choix</a>
              </motion.button>
              <motion.button
                className="bg-primary-100 hover:bg-primary-100/80 font-semibold text-[11px] md:text-lg text-white h-12 px-10 rounded-full"
                initial="hidden"
                whileInView="visible"
                variants={slideUp}
                transition={{ duration: 1, delay: 0.6 }}
              >
                <a
                  href="https://api.whatsapp.com/send?phone=33668733010"
                  target="_blank"
                >
                  Commandez
                </a>
              </motion.button>
            </div>
            <div className="flex flex-col md:flex-row items-center justify-center gap-4">
              <img src="/assets/images/users-group.png" className="w-32 h-10" />
              <img
                src="/assets/images/rating-users.png"
                className="w-40 h-12 hidden md:block"
              />
              <img
                src="/assets/images/rating-users-2.png"
                className="w-40 h-12 block md:hidden"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="w-full bg-primary-40 grid lg:grid-cols-2 pb-8 md:pb-0 pt-8 rounded-3xl mt-8 lg:mt-16">
        <motion.div
          className="flex items-center justify-center "
          initial="hidden"
          whileInView="visible"
          variants={slideLeft}
          transition={{ duration: 1 }}
        >
          <div className="flex flex-col items-center md:items-start gap-4">
            <h2 className="text-3xl md:text-5xl font-medium text-primary-50 md:leading-[3.5rem]  text-center md:text-start">
              Améliorez votre <br />
              productivité
            </h2>
            <h5 className="text-primary-55 font-light text-xl md:text-3xl md:leading-10 text-center md:text-start">
              Grâce à une offre pensée <br />
              pour vous
            </h5>
            <div className="flex items-center md:items-start mt-4">
              <a
                href="https://api.whatsapp.com/send?phone=33668733010"
                target="_blank"
                className="flex items-center bg-primary-100 hover:bg-primary-100/80 font-normal text-sm text-white h-10 px-6 rounded-full"
              >
                Commandez
              </a>
            </div>
          </div>
        </motion.div>
        <motion.div
          className="z-20 flex justify-center mt-8 md:mt-0"
          initial="visible"
          whileInView="visible"
          variants={slideRight}
          transition={{ duration: 1 }}
        >
          <img
            src="/assets/images/instructions-1.png"
            className="hidden lg:block"
          />
          <img src="/assets/images/instructions-2.png" className=" lg:hidden" />
        </motion.div>
      </section>
      <section className="w-full md:w-full mt-6 md:mt-16 bg-primary-60 rounded-3xl p-8 md:p-16">
        <div className="flex flex-col gap-4 max-w-7xl mx-auto">
          <motion.h1
            className="font-bold text-4xl md:text-7xl text-primary-65"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1 }}
          >
            Thermique ou électrique <br />À vous le choix
          </motion.h1>
          <motion.p
            className="font-normal text-base md:text-2xl text-white/75 text-start"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.2 }}
          >
            De l'électrique au thermique, de la puissance du moteur aux <br />
            conditions d'acquisition, trouvez toutes les informations
            <br />
            nécessaires pour vous faciliter votre choix.
          </motion.p>
          <div className="flex flex-col xl:flex-row items-start mt-4 justify-between">
            <a
              href="#our-models"
              className="bg-primary-100 flex items-center hover:bg-primary-100/80 font-normal text-sm text-white h-10 px-6 rounded-full"
            >
              En savoir plus
            </a>
            <img
              src="/assets/images/motor-img.png"
              className="lg:w-[999px] lg:h-[950px] mt-10 xl:-mt-24"
            />
          </div>
        </div>
        <div
          id="how-it-works"
          className="bg-white max-w-6xl mx-auto px-4 xl:px-0 py-4 lg:py-8 grid xl:grid-cols-2 gap-16 rounded-2xl -mb-64 mt-20"
        >
          <motion.div
            className="xl:flex items-center justify-end"
            initial="hidden"
            whileInView="visible"
            variants={slideLeft}
            transition={{ duration: 1 }}
          >
            <div className="flex flex-col gap-2 md:gap-4">
              <h2 className="text-3xl md:text-5xl font-medium text-inter-600 text-primary-70 xl:leading-[3.5rem]">
                Comment être <br /> propriétaire d'un <br /> véhicule chez{" "}
                <br className="block md:hidden" />
                <span className="text-primary-100">
                  Infin<span className="text-6xl">X</span>
                </span>
              </h2>
              <h5 className="text-primary-75 font-bold text-xs md:text-xl">
                Devenir propriétaire d'un véhicule pour booster <br /> ses
                activités “pro” n'a jamais été aussi simple
              </h5>
              <div className="flex items-start mt-4">
                <button className="bg-primary-100 hover:bg-primary-100/80 font-normal text-sm text-white h-10 px-6 rounded-full">
                  Contactez-nous
                </button>
              </div>
            </div>
          </motion.div>
          <motion.div
            className="flex items-center justify-start"
            initial="hidden"
            whileInView="visible"
            variants={slideRight}
            transition={{ duration: 1 }}
          >
            <img
              src="/assets/images/proprio.png"
              className="xl:h-96 bg-cover  "
            />
          </motion.div>
        </div>
      </section>
      <section className="max-w-xs md:max-w-sm lg:max-w-7xl mx-auto mt-60 md:mt-52 grid lg:grid-cols-3 gap-2">
        <motion.div
          className="bg-primary-40/5 flex items-center gap-4 rounded-md px-4"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1 }}
        >
          <Content1Icon />
          <span className="text-sm md:text-xl  font-medium text-primary-80">
            Je postule en ligne ou au travers d'un commercial
          </span>
        </motion.div>
        <motion.div
          className="bg-primary-40/5 flex items-center gap-4 rounded-md px-4"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <Content2Icon />
          <span className="text-sm md:text-xl  font-medium text-primary-80">
            Mon éligibilité est évaluée en moins de 5 jours
          </span>
        </motion.div>
        <motion.div
          className="bg-primary-40/5 flex items-center gap-4 rounded-md px-4"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <Content3Icon />
          <span className="text-sm md:text-xl font-medium text-primary-80">
            Je signe un contrat et je récupère mon véhicule
          </span>
        </motion.div>
      </section>
      <section className="mt-6 p-8 w-full bg-primary-40 rounded-3xl flex flex-col justify-center items-center gap-8">
        <motion.div
          className="flex flex-col justify-center items-center"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1 }}
        >
          <h2 className="text-4xl md:text-5xl font-medium text-primary-50 text-center md:leading-[3.5rem]">
            Notre <br className="block md:hidden" /> engagement
          </h2>
          <h5 className="text-primary-55 font-light text-lg leading-10">
            Impacter favorablement notre société
          </h5>
        </motion.div>
        <hr className="w-full md:w-3/5 h-[0.5px] bg-black" />
        <motion.div
          className="grid lg:grid-cols-3 gap-6"
          initial="hidden"
          whileInView="visible"
          variants={slideUp}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <motion.div
            className="bg-white rounded-3xl px-4 py-6 flex flex-col gap-4"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <h3 className="text-xl font-medium text-primary-50">
              Contribuer à la transition écologique
            </h3>
            <h5 className="text-primary-55 font-light text-sm md:text-lg h-28 mb-2 md:mb-0">
              En adoptant des motos électriques, InfinX Mobility réduit les
              émissions de CO2 et la pollution sonore en Afrique, favorisant
              ainsi un environnement urbain plus propre et durable.
            </h5>
            <img src="/assets/images/engagement-1.png" />
          </motion.div>
          <motion.div
            className="bg-white rounded-3xl px-4 py-6 flex flex-col gap-4"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.6 }}
          >
            <h3 className="text-xl font-medium text-primary-50">
              Lutter contre la pauvreté
            </h3>
            <h5 className="text-primary-55 font-light text-sm md:text-lg h-28 mb-2 md:mb-0">
              Notre offre crée des opportunités économiques en réduisant les
              coûts de transport et d'entretien, tout en favorisant l'emploi
              local et le développement durable.
            </h5>
            <img src="/assets/images/engagement-2.png" />
          </motion.div>
          <motion.div
            className="bg-white rounded-3xl px-4 py-6 flex flex-col gap-4"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <h3 className="text-xl font-medium text-primary-50">
              Contribuer à l'inclusion financière
            </h3>
            <h5 className="text-primary-55 font-light text-sm md:text-lg h-28 mb-2 md:mb-0">
              Le mécanisme de LOA de InfinX Mobility permet à un plus grand
              nombre de personnes d'accéder à des moyens de transport
              abordables, favorisant ainsi l'inclusion financière en Afrique.
            </h5>
            <img src="/assets/images/engagement-3.png" />
          </motion.div>
        </motion.div>
      </section>
      <section className="flex flex-col justify-center items-center gap-8 mt-10 md:mt-20">
        <motion.div
          className="px-4 py-1 border border-primary-85 rounded-full"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1 }}
        >
          <span>Nos atouts</span>
        </motion.div>
        <motion.h1
          className="font-light text-3xl lg:text-7xl text-center max-w-xs md:max-w-sm lg:max-w-6xl"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1, delay: 0.2 }}
        >
          Nous simplifions l'acquisition de{" "}
          <span className="text-primary-100"> véhicules professionnels </span>
          aux acteurs du{" "}
          <span className="text-primary-100">secteur informel</span>
        </motion.h1>
        <motion.div
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8"
          initial="hidden"
          whileInView="visible"
          variants={slideUp}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <motion.img
            src="/assets/images/vehicule.png"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.6 }}
          />
          <motion.div
            className="bg-primary-40 px-6 mx:px-16 rounded-3xl h-full flex flex-col justify-evenly"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.6 }}
          >
            <h3 className="text-lg md:text-4xl font-light">
              Moto <br />
              taximen
            </h3>
            <hr className="w-24 md:w-36 h-[2px] bg-black" />
            <h5 className="text-primary-90 font-light text-[10px] md:text-lg">
              Tu fais du transport urbain par moto et tu as des difficultés à
              financer ton activité ; nous avons pensé à toi
            </h5>
          </motion.div>
          <motion.img
            src="/assets/images/vehicule-1.png"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.6 }}
          />
          <motion.div
            className="bg-primary-65 px-6 mx:px-16 rounded-3xl h-full flex flex-col justify-evenly"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.8 }}
          >
            <h3 className="text-lg md:text-4xl font-light text-white">
              Livreur <br />
              de colis
            </h3>
            <hr className="w-24 md:w-36 h-[2px] bg-white" />
            <h5 className="text-white font-light text-[10px] md:text-lg">
              Tu fais de la livraison de colis et tu n'as pas accès aux
              financements classiques pour ton activité ? Nous t'attendons
            </h5>
          </motion.div>

          <motion.div
            className="bg-primary-95 5 px-6 mx:px-16 rounded-3xl h-full flex flex-col justify-evenly"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 1 }}
          >
            <h3 className="text-lg md:text-4xl font-light text-white">
              Coursier
            </h3>
            <hr className="w-24 md:w-36 h-[2px] bg-white" />
            <h5 className="text-white font-light text-[10px] md:text-lg">
              Tu es coursier et tu ne recherches pas seulement une moto mais une
              offre complète et facile d'accès ? Nous sommes là
            </h5>
          </motion.div>
          <motion.img
            src="/assets/images/vehicule-2.png"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 0.8 }}
          />
          <motion.div
            className="bg-primary-40 5 px-6 mx:px-16 rounded-3xl h-full flex flex-col justify-evenly"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 1.2 }}
          >
            <h3 className="text-lg md:text-4xl font-light">
              Livreur <br />
              de repas
            </h3>
            <hr className="w-24 md:w-36 h-[2px] bg-black" />
            <h5 className="text-primary-90 font-light text-[10px] md:text-lg">
              Tu fais de la livraison de repas au travers de plateformes
              partenaires et tu veux acquérir un outil de travail ? Tu es au bon
              endroit
            </h5>
          </motion.div>
          <motion.img
            src="/assets/images/vehicule-3.png"
            initial="hidden"
            whileInView="visible"
            variants={fadeIn}
            transition={{ duration: 1, delay: 1 }}
          />
        </motion.div>
      </section>

      <section
        id="blog"
        className="max-w-sm md:max-w-sm lg:max-w-7xl mx-auto flex flex-col gap-4 md:gap-8 mt-20"
      >
        <div className="flex flex-col justify-center items-center gap-4">
          <h2 className="text-3xl md:text-5xl font-medium text-primary-50">
            Nos articles
          </h2>
          <h5 className="text-primary-55 font-light text-base md:text-lg">
            Informez vous sur notre actualités et sur d'avantage de choses dans
            notre domaine
          </h5>
        </div>
        <div className="grid lg:grid-cols-3 gap-4 md:gap-6">
          {!isEmpty(data) ? (
            data.map((item) => {
              const shareUrl = `https://infinx-mobility.com/detail-blog/${item.id}`;
              const description = item.content
                ? item.content.replace(/<[^>]*>/g, "").substring(0, 100) + "..."
                : "";
              const imageUrl =
                extractFirstImageSrc(item.content) || "/assets/logo/logo.png";

              // Fonction pour ouvrir la fenêtre de partage avec pré-remplissage
              const handleShare = (platform: any) => {
                let url;
                switch (platform) {
                  case "facebook":
                    url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      shareUrl
                    )}&quote=${encodeURIComponent(
                      `${item.title} - ${description}`
                    )}`;
                    break;
                  case "twitter":
                    url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      item.title
                    )}&url=${encodeURIComponent(shareUrl)}`;
                    break;
                  case "linkedin":
                    url = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                      shareUrl
                    )}&title=${encodeURIComponent(
                      item.title
                    )}&summary=${encodeURIComponent(description)}`;
                    break;
                  default:
                    return;
                }

                window.open(url, "_blank", "width=600,height=400");
              };

              return (
                <a href={`/detail-blog/${item.id}`} key={item.id}>
                  <div className="bg-white rounded-3xl px-4 md:py-6 flex flex-col gap-2 cursor-pointer">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        className="w-full h-full bg-cover"
                        alt={item.title}
                      />
                    ) : (
                      <img
                        src="/assets/logo/logo.png"
                        className="w-full h-full bg-cover"
                        alt="Default logo"
                      />
                    )}
                    <h5 className="text-primary-50 font-semibold text-base md:text-lg md:h-20">
                      {item.title}
                    </h5>
                    <h3 className="text-primary-55 font-light text-sm md:text-lg">
                      {formatDateTimeWithDay(item.date)}
                    </h3>
                    <div className="flex items-center gap-4">
                      {/* Bouton Facebook */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShare("facebook");
                        }}
                        className="focus:outline-none"
                      >
                        <FacebookIcon />
                      </button>

                      {/* Bouton Twitter */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShare("twitter");
                        }}
                        className="focus:outline-none"
                      >
                        <TwitterIcon />
                      </button>

                      {/* Bouton LinkedIn */}
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShare("linkedin");
                        }}
                        className="focus:outline-none"
                      >
                        <LinkedinIcon />
                      </button>
                    </div>
                  </div>
                </a>
              );
            })
          ) : (
            <></>
          )}
          {/* <div className="bg-white rounded-3xl px-4 py-8 md:py-6 flex flex-col gap-2">
            <img src="/assets/images/article-2.png" />
            <h3 className="text-primary-55 font-light text-xs md:text-lg">
              Finance
            </h3>
            <h5 className="text-primary-50 font-semibold text-base md:text-lg md:h-20">
              De l’électrique au thermique, De la puissance du moteur aux
              conditions d’acquisition.
            </h5>
            <h3 className="text-primary-55 font-light text-sm md:text-lg">
              January 11, 2024 by Mileana Vanessa
            </h3>
            <div className="flex items-center gap-4">
              <FacebookIcon />
              <TwitterIcon />
              <a
                href="https://www.linkedin.com/company/infinx-mobility/"
                target="_blank"
              >
                <LinkedinIcon />
              </a>
            </div>
          </div>
          <div className="bg-white rounded-3xl px-4 md:py-6 flex flex-col gap-2">
            <img src="/assets/images/article-3.png" />
            <h3 className="text-primary-55 font-light text-xs md:text-lg">
              Finance
            </h3>
            <h5 className="text-primary-50 font-semibold text-base md:text-lg md:h-20">
              De l’électrique au thermique, De la puissance du moteur aux
              conditions d’acquisition.
            </h5>
            <h3 className="text-primary-55 font-light text-sm md:text-lg">
              January 11, 2024 by Mileana Vanessa
            </h3>
            <div className="flex items-center gap-4">
              <FacebookIcon />
              <TwitterIcon />
              <a
                href="https://www.linkedin.com/company/infinx-mobility/"
                target="_blank"
              >
                <LinkedinIcon />
              </a>
            </div>
          </div> */}
        </div>
      </section>

      <section
        id="contact"
        className="mt-20 flex flex-col lg:flex-row justify-between w-full lg:h-[800px] gap-32 md:gap-0 bg-contact-banner-2 md:bg-contact-banner bg-cover bg-center bg-no-repeat rounded-2xl py-6 md:py-16 pb-16 px-4 md:px-12"
      >
        <div className="flex flex-col gap-6">
          <div className="bg-white/20 px-6 py-3 flex flex-col gap-2 md:gap-3 rounded-xl border border-white">
            <h2 className="text-2xl md:text-4xl font-medium text-white text-inter-600">
              Siège social
            </h2>
            <hr className="h-[1px] bg-white" />
            <div className="flex flex-row gap-4">
              <a
                href="https://api.whatsapp.com/send?phone=33668733010"
                target="_blank"
                className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2"
              >
                <WhatsappIcon /> +33 06 68 73 30 10
              </a>
              <a
                href="https://api.whatsapp.com/send?phone=330783000334"
                target="_blank"
                className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2"
              >
                <PhoneIcon /> +33 07 83 000 3 34
              </a>
            </div>
            <a
              href="mailto:contact@infinx-mobility.com"
              target="_blank"
              className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2"
            >
              <LocationIcon /> contact@infinx-mobility.com
            </a>
            <h5 className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2 leading-5">
              <LocationIcon /> 57 Boulevard Démorieux <br /> 72000 Le Mans -
              France
            </h5>
          </div>
          <div className="bg-white/20 px-6 pt-3 pb-[60px] flex flex-col gap-3 rounded-xl border border-white">
            <h2 className="text-2xl md:text-4xl font-medium text-white text-inter-600">
              Abidjan
            </h2>
            <hr className="h-[1px] bg-white" />
            <div className="flex flex-row gap-4">
              <a
                href="https://api.whatsapp.com/send?phone=2250747499447"
                target="_blank"
                className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2"
              >
                <PhoneIcon /> +225 0747499447
              </a>
            </div>
            <h5 className="text-white text-inter-600 font-light text-sm md:text-lg flex items-center gap-2 leading-5">
              <LocationIcon /> Riviera 3 Triangle; <br /> Impact Hub
            </h5>
          </div>
        </div>
        <div className="flex flex-col justify-start items-start gap-4">
          <div className="px-2 bg-white rounded-full">
            <span className="text-xs">Contact</span>
          </div>
          <h1 className="font-light text-4xl w-full md:text-7xl text-white">
            Inscription à la <br />
            newsletter
          </h1>
          <h5 className="text-white/90 font-light text-xs md:text-lg">
            Restez informé et ne manquez jamais <br /> une mise à jour avec
            notre newsletter.
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="bg-white rounded-3xl p-4 flex flex-col w-full gap-4">
              <div className="flex flex-col w-full gap-2">
                <label className="text-xs md:text-base">Name</label>
                <input
                  type="text"
                  id="fullName"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  className="h-12 text-base w-[265px] md:w-full font-normal placeholder:text-xs md:placeholder:text-base placeholder:font-normal border rounded-lg px-4 focus:outline-none"
                  placeholder="Your Name"
                  required={true}
                />
              </div>
              <div className="flex flex-col w-full gap-2">
                <label className="text-xs md:text-base">Email</label>
                <input
                  type="email"
                  className="h-12 text-base w-[265px] md:w-full font-normal placeholder:text-xs md:placeholder:text-base placeholder:font-normal border rounded-lg px-4 focus:outline-none"
                  placeholder="Your Email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required={true}
                />
              </div>
              <div className="flex flex-col w-full gap-2">
                <label className="text-xs md:text-base">Message</label>
                <textarea
                  className="text-base font-normal w-[265px] md:w-full placeholder:text-xs md:placeholder:text-base placeholder:font-normal border rounded-lg px-4 focus:outline-none"
                  rows={4}
                  cols={40}
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
              </div>
              <button
                disabled={loading}
                type="submit"
                className="bg-primary-85 hover:bg-primary-85/80 font-normal text-xs md:text-base text-header text-white/80 py-2 px-4 rounded-full"
              >
                {loading ? "Patienter..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </section>

      <section
        id="our-models"
        className="relative mt-6 p-4 md:p-16 pb-2 bg-primary-40 rounded-3xl flex flex-col justify-center items-center lg:justify-start lg:items-start gap-8"
      >
        <motion.h2
          className="text-3xl md:text-5xl font-medium text-primary-50 leading-[3.5rem]"
          initial="hidden"
          whileInView="visible"
          variants={fadeIn}
          transition={{ duration: 1 }}
        >
          Modèles
        </motion.h2>
        <motion.div
          className="flex flex-col lg:flex-row overflow-hidden relative w-full"
          initial="hidden"
          whileInView="visible"
          variants={slideUp}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <div className="flex flex-col lg:flex-row lg:animate-scroll whitespace-nowrap md:max-w-7xl relative">
            {[...motors, ...motors].map((item, index) => (
              <motion.div
                key={index}
                className="bg-white rounded-3xl lg:w-80 flex flex-col scroll-item mr-0 lg:mr-8 mb-4 lg:mb-0 z-50"
                style={{ flex: "0 0 auto" }} // Assure que chaque item conserve sa largeur
                initial="hidden"
                whileInView="visible"
                variants={fadeIn}
                transition={{ duration: 1, delay: index * 0.2 }}
              >
                <img src={item.image} className="pb-4" alt={item.label} />
                <div className="px-4 py-6">
                  <h3 className="text-xl font-medium text-primary-50">
                    {item.label}
                  </h3>
                  <div className="w-full flex items-center justify-between ">
                    <h5 className="text-primary-55 font-light text-lg">
                      {item.description}
                    </h5>
                    <button
                      ref={buttonRef}
                      onClick={handleOpenMenu}
                      className="bg-primary-100 hover:bg-primary-100/80 font-normal text-lg text-header text-white h-10 px-4 rounded-full"
                    >
                      Détails
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
        <Menu>
          {({ open }) => (
            <>
              <Menu.Button ref={buttonRef} onClick={handleOpenMenu} />

              <Transition
                show={open}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <div className="absolute right-10 max-w-7xl z-50 bottom-0 md:-bottom-52 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-3xl shadow-lg outline-none">
                  <div className="p-8 w-full flex flex-col gap-6">
                    <div className="grid xl:grid-cols-3 gap-4">
                      <div className="col-span-2 grid lg:grid-cols-2 gap-4">
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <img
                            src="/assets/images/image-1.png"
                            className="w-15 h-14"
                          />
                          <p className="font-light text-xs lg:text-sm ">
                            Lampe frontale 12 V, 35/35 W Queue / feu
                            <br />
                            de freinage 12 V, 21/5 W Indicateurs 12 V,
                            <br />
                            10/10 W Système de mise à feu CDI
                            <br />
                            numérique A / C
                          </p>
                        </div>
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <img
                            src="/assets/images/image-2.png"
                            className="w-15 h-14"
                          />
                          <p className="font-light text-xs lg:text-sm ">
                            Pneu avant 2.75 x 17 Pneu arrière <br /> 3.00 x 17
                            Tambour de frein avant
                            <br /> 130 MM DIA Tambour de frein
                            <br /> arrière 110 MM DIA
                          </p>
                        </div>
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <img
                            src="/assets/images/image-3.png"
                            className="w-15 h-14"
                          />
                          <p className="font-light text-xs lg:text-sm ">
                            Suspension avant Fourche téle- <br />
                            scopique hydraulique, Suspension <br /> arrière Avec
                            5 niveaux de choc <br /> réglable (course de 79 mm)
                          </p>
                        </div>
                        <div className="flex flex-col gap-4">
                          <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                            <img
                              src="/assets/images/image-4.png"
                              className="w-15 h-10"
                            />
                            <p className="font-light text-xs lg:text-sm ">
                              Électrique
                            </p>
                          </div>
                          <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                            <img
                              src="/assets/images/image-5.png"
                              className="w-15 h-10"
                            />
                            <p className="font-light text-xs lg:text-sm ">
                              Conditions de paiement <br />
                              mentionnées sur le dévis
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="col-span-2 xl:col-span-1 flex flex-col gap-4">
                        <h3 className="text-base lg:text-2xl font-semibold">
                          Services annexes
                        </h3>
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <p className="font-light text-xs lg:text-sm ">
                            Assurance annuelle offerte
                          </p>
                        </div>
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <p className="font-light text-xs lg:text-sm ">
                            Maintenance preventive offerte
                          </p>
                        </div>
                        <div className="bg-primary-35 p-4 flex items-start gap-4 rounded-lg">
                          <p className="font-light text-xs lg:text-sm ">
                            Véhicules mis à disposition avec <br /> toute sa
                            documentation
                          </p>
                        </div>
                      </div>
                    </div>
                    <div>
                      <a
                        href="https://api.whatsapp.com/send?phone=33668733010"
                        className="bg-primary-100 hover:bg-primary-100/80 font-normal text-lg text-header text-white h-10 px-4 py-2 rounded-full"
                      >
                        Demandez le devis
                      </a>
                    </div>
                  </div>
                </div>
              </Transition>
            </>
          )}
        </Menu>
      </section>

      {/* Section de présentation de l'entreprise */}
      <Footer />

      <CookieConsent />
    </main>
  );
}
